import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { authService } from '@/api/services/auth.service'
import { tokenStorage } from '@/utils/token-storage'
import type { LoginDto, User } from '@/types/api.types'

export const useAuthStore = defineStore('auth', () => {
  const user = ref<User | null>(null)
  const token = ref<string | null>(tokenStorage.get())

  const isAuthenticated = computed(() => !!token.value)
  const isAdmin = computed(() => user.value?.isAdmin ?? false)

  async function login(dto: LoginDto): Promise<void> {
    const result = await authService.login(dto)
    token.value = result.token
    user.value = result.user
    tokenStorage.set(result.token)
  }

  async function fetchMe(): Promise<void> {
    user.value = await authService.me()
  }

  function logout(): void {
    user.value = null
    token.value = null
    tokenStorage.clear()
  }

  return { user, token, isAuthenticated, isAdmin, login, fetchMe, logout }
})
